import { Injectable } from "@angular/core";
import { UtentiMasterService } from "./utenti-master.service";
import { LoaderService } from "../../service/loader.service";
import { lastValueFrom } from "rxjs";

@Injectable(
  { providedIn: 'root' }
)
export class UtentiMasterResolver {
  constructor(
    private loader: LoaderService,
    private utentiMasterService: UtentiMasterService
  ) { }

  async resolve(): Promise<any> {

    this.loader.show();

    return lastValueFrom(
      this.utentiMasterService.list()
    ).finally(() => this.loader.hide());
  }
}
